import { useMemo } from 'react';
import { Typography } from '@mui/material';

import NumberTypo from 'src/components/common/Number';
import Image from 'src/components/Image';
import type { Coin } from 'src/types/coin';
import { toDisplayDenomAmount } from 'src/utils/number';

import {
  Base02TextContainer,
  CoinButton,
  Container,
  Divider,
  LeftContainer,
  LeftImageContainer,
  LeftTextContainer,
  RightCommissionContainer,
  RightContainer,
} from './styled';

type CoinItemProps = {
  coinInfo: Coin;
  onClick?: (coinInfo: Coin) => void;
};

export default function CoinItem({ coinInfo, onClick }: CoinItemProps) {
  const displayDenomAmount = useMemo(() => toDisplayDenomAmount(coinInfo.balance, coinInfo.decimals), [coinInfo.balance, coinInfo.decimals]);
  return (
    <Container>
      <Divider />
      <CoinButton
        onClick={() => {
          onClick?.(coinInfo);
        }}
      >
        <LeftContainer>
          <LeftImageContainer>
            <Image src={coinInfo.image} />
          </LeftImageContainer>
          <LeftTextContainer>
            <Typography variant="h3">{coinInfo.symbol}</Typography>
          </LeftTextContainer>
        </LeftContainer>

        <RightContainer>
          <RightCommissionContainer>
            <Base02TextContainer>
              <Typography variant="h9">Available</Typography>
            </Base02TextContainer>
            &nbsp;
            <NumberTypo typoOfIntegers="h4" typoOfDecimals="h6" fixed={6}>
              {displayDenomAmount}
            </NumberTypo>
          </RightCommissionContainer>
        </RightContainer>
      </CoinButton>
    </Container>
  );
}
